import * as React from "react";
import MenuPage from "./menupage.component";

interface IProps {}

interface IState {
  isVisible: Boolean;
}

class Menu extends React.Component<IProps, IState> {
  handleClick = () => {
    this.setState({
      isVisible: !this.state.isVisible
    });
  };

  constructor(props: IProps) {
    super(props);
    this.state = { isVisible: false };
  }

  adClassesIcon = () => {
    return "menu-icon " + (this.state.isVisible === true ? "cross" : "");
  };

  render(): JSX.Element {
    return (
      <div className="main-menu">
        {/* this is menu container */}
        <div onClick={this.handleClick} className={this.adClassesIcon()}>
          <span />
          <span />
          <span />
        </div>
        <MenuPage isVisible={this.state.isVisible} />
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/menu.component.tsx